import { toast } from "react-toastify";
// import { EmployeeServices } from "./EmployeeService";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { successAlert } from "../../Global/GlobalSlice";
import { PaymentService } from "./PaymentService";

const initialState = {
  payment: "",
};

export const CreatePaymentServiceClass = createAsyncThunk(
  "paymentService/CreatePaymentService",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().CreatePaymentSetup(payload);

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreatePaymentServiceSubclass = createAsyncThunk(
  "paymentService/CreatePaymentSubclass",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().CreatePaymentSubclass(
          payload
        );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreatePaymentSubclassComp = createAsyncThunk(
  "paymentService/CreatePaymentSubclassComponent",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().CreatePaymentSubclassComponent(
          payload
        );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreatePaymentSetupLimit = createAsyncThunk(
  "paymentService/CreatePaymentSetupLimit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().CreatePaymentSetupLimit(
          payload
        );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdatePaymentServiceClass = createAsyncThunk(
  "paymentService/UpdatePaymentService",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().UpdatePaymentSetup(payload);

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdatePaymentServiceSubClass = createAsyncThunk(
  "paymentService/UpdatePaymentSubclass",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().UpdatePaymentSubclass(
          payload
        );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdatePaymentSubClassComp = createAsyncThunk(
  "paymentService/UpdatePaymentSubclassComp",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().UpdatePaymentSubclassComponent(
          payload
        );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdatePaymentLimit = createAsyncThunk(
  "paymentService/UpdatePaymentLimitss",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().UpdatePaymentLimit(payload);

      if (response?.data?.successful === true) {
        toast.success(response?.data?.statusMessage);
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DisablePaymentClass = createAsyncThunk(
  "paymentService/DisableClass",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await PaymentService.PaymentServiceSetup().DisableClass(
        payload
      );

      if (response?.data?.successful === true) {
        // const { id } = payload;
        // toast.success(response?.data?.statusMessage);
        toast.success(`Class was disabled successfully`);
        // dispatch(
        //   successAlert({
        //     message: response?.data?.statusMessage,
        //   })
        // );
      }

      if (response?.data?.successful === false) {
        toast.error(response?.data?.statusMessage);
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DisableSubClassComp = createAsyncThunk(
  "paymentService/DisableSubComponent",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().DisableSubComponent(payload);

      if (response?.data?.successful === true) {
        // const { id } = payload;
        // toast.success(response?.data?.statusMessage);
        toast.success(`Component was disabled successfully`);
        // dispatch(
        //   successAlert({
        //     message: response?.data?.statusMessage,
        //   })
        // );
      }

      if (response?.data?.successful === false) {
        toast.error(response?.data?.statusMessage);
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DisablePaymentSubClass = createAsyncThunk(
  "paymentService/DisableSubClass",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().DisableSubClass(payload);

      if (response?.data?.successful === true) {
        // const { id } = payload;
        // toast.success(response?.data?.statusMessage);
        toast.success(`Subclass was disabled successfully`);
        // dispatch(
        //   successAlert({
        //     message: response?.data?.statusMessage,
        //   })
        // );
      }

      if (response?.data?.successful === false) {
        toast.error(response?.data?.statusMessage);
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DisablePayLimit = createAsyncThunk(
  "paymentService/DisablePayLimit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().DisablePaymentLimit(payload);

      if (response?.data?.successful === true) {
        // const { id } = payload;
        // toast.success(response?.data?.statusMessage);
        toast.success(`Payment limit was disabled successfully`);
        // dispatch(
        //   successAlert({
        //     message: response?.data?.statusMessage,
        //   })
        // );
      }

      if (response?.data?.successful === false) {
        toast.error(response?.data?.statusMessage);
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllPaymentService = createAsyncThunk(
  "paymentService/GetAllPaymentService",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().GetAllPaymentService(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllPaymentSubclass = createAsyncThunk(
  "paymentService/GetAllPaymentSubclass",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().GetAllPaymentSubclass(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllPaymentSubclassComp = createAsyncThunk(
  "paymentService/GetAllPaymentSubclassComponent",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().GetAllPaymentSubclassComp(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllPaymentCashAdvance = createAsyncThunk(
  "paymentService/GetPaymentCashAdvance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().GetAllPaymentCashAdvance(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllPaymentLimits = createAsyncThunk(
  "paymentService/GetAllPaymentLImit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().GetAllPaymentLimit(payload);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllPaymentSerHistory = createAsyncThunk(
  "paymentService/GetAllPaymentServiceHistory",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().GetAllPaymentServiceHistory(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllCadrePosition = createAsyncThunk(
  "paymentService/GetAllCadrePosition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().GetAllCadrePosition(payload);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetPaymentServiceByID = createAsyncThunk(
  "paymentService/GetPaymentServiceByID",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().GetPaymentServiceByID(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetPaymentSubclassByID = createAsyncThunk(
  "paymentService/GetPaymentSubclassByID",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().GetPaymentSubclassByID(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetPaymentSubclassCompByID = createAsyncThunk(
  "paymentService/GetPaymentSubclassCompByID",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PaymentService.PaymentServiceSetup().GetPaymentSubclassCompByID(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const PaymentServiceSlice = createSlice({
  name: "paymentService",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(CreatePaymentServiceClass.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(CreatePaymentServiceClass.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(CreatePaymentServiceClass.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    // Create Payment Subclass
    builder.addCase(CreatePaymentServiceSubclass.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(CreatePaymentServiceSubclass.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(CreatePaymentServiceSubclass.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    // Create Payment Subclass Component
    builder.addCase(CreatePaymentSubclassComp.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(CreatePaymentSubclassComp.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(CreatePaymentSubclassComp.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    // Create Payment Setup Limit
    builder.addCase(CreatePaymentSetupLimit.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(CreatePaymentSetupLimit.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(CreatePaymentSetupLimit.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    // Update Payment Service Class
    builder.addCase(UpdatePaymentServiceClass.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(UpdatePaymentServiceClass.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(UpdatePaymentServiceClass.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    // Update Payment Service SubClass
    builder.addCase(UpdatePaymentServiceSubClass.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(UpdatePaymentServiceSubClass.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(UpdatePaymentServiceSubClass.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    // Update Payment Subclass Comp
    builder.addCase(UpdatePaymentSubClassComp.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(UpdatePaymentSubClassComp.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(UpdatePaymentSubClassComp.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    // Update Payment Limit
    builder.addCase(UpdatePaymentLimit.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(UpdatePaymentLimit.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(UpdatePaymentLimit.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    //   Handle Disable Class
    builder.addCase(DisablePaymentClass.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(DisablePaymentClass.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(DisablePaymentClass.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    //   Handle Disable SubClass
    builder.addCase(DisablePaymentSubClass.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(DisablePaymentSubClass.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(DisablePaymentSubClass.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    //   Handle Disable SubComponent
    builder.addCase(DisableSubClassComp.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(DisableSubClassComp.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(DisableSubClassComp.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    //   Handle Disable PaymentLimit
    builder.addCase(DisablePayLimit.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(DisablePayLimit.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(DisablePayLimit.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    // GetAllPaymentService
    builder.addCase(GetAllPaymentService.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllPaymentService.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        allPaymentServiceData: action.payload,
      };
    });
    builder.addCase(GetAllPaymentService.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });

    // GetAllPaymentSubclass
    builder.addCase(GetAllPaymentSubclass.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllPaymentSubclass.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        allPaymentSubclassData: action.payload,
      };
    });
    builder.addCase(GetAllPaymentSubclass.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });

    // GetAllPaymentSubclassComponents
    builder.addCase(GetAllPaymentSubclassComp.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllPaymentSubclassComp.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        allPaymentSubclassCompData: action.payload,
      };
    });
    builder.addCase(GetAllPaymentSubclassComp.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });

    // GetAllCashAdvance
    builder.addCase(GetAllPaymentCashAdvance.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllPaymentCashAdvance.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        allPaymentCashAdvance: action.payload,
      };
    });
    builder.addCase(GetAllPaymentCashAdvance.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });

    // GetAllPaymentLimit
    builder.addCase(GetAllPaymentLimits.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllPaymentLimits.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        allPaymentLimitData: action.payload,
      };
    });
    builder.addCase(GetAllPaymentLimits.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });

    // GetAllPaymentServiceHistory
    builder.addCase(GetAllPaymentSerHistory.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllPaymentSerHistory.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        allPaymentServiceHistory: action.payload,
      };
    });
    builder.addCase(GetAllPaymentSerHistory.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });

    // GetAllCadrePosition
    builder.addCase(GetAllCadrePosition.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllCadrePosition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        allCadrePosition: action.payload,
      };
    });
    builder.addCase(GetAllCadrePosition.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });

    // GetPaymentServiceByID
    builder
      .addCase(GetPaymentServiceByID.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetPaymentServiceByID.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          paymentServiceData: action.payload,
        };
      })
      .addCase(GetPaymentServiceByID.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.error.message,
        };
      });

    // GetPaymentSubclassByID
    builder.addCase(GetPaymentSubclassByID.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetPaymentSubclassByID.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        paymentSubclassData: action.payload,
      };
    });
    builder.addCase(GetPaymentSubclassByID.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });

    // GetPaymentSubclassCompByID
    builder.addCase(GetPaymentSubclassCompByID.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetPaymentSubclassCompByID.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        paymentSubclassCompData: action.payload,
      };
    });
    builder.addCase(GetPaymentSubclassCompByID.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });
  },
});

export default PaymentServiceSlice.reducer;
